import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "../i18n";
import { HERALDRY } from "../brand";

export default function About() {
  const { t } = useI18n();
  return (
    <div className="bg-black text-white pt-32 pb-32">
      <section className="max-w-[1600px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }} className="md:col-span-7">
          <div className="text-xs font-bold tracking-[0.3em] uppercase text-blood mb-6">{t.about.kicker}</div>
          <h1 className="font-black text-5xl md:text-7xl lg:text-8xl leading-[0.85] tracking-tighter uppercase mb-12">
            The <span className="text-blood">return</span> of<br/>the king.
          </h1>
          <p className="text-white/70 text-lg leading-relaxed mb-6 max-w-xl">{t.about.body1}</p>
          <p className="text-white/70 text-lg leading-relaxed max-w-xl">{t.about.body2}</p>
        </motion.div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}
          transition={{ duration: 1.2, delay: 0.3 }} className="md:col-span-5">
          <div className="aspect-[3/4] overflow-hidden">
            <img src={HERALDRY.knightsPainting} alt="Knights" className="w-full h-full object-cover" />
          </div>
        </motion.div>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 md:px-12 mt-32 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div className="text-center">
          <img src={HERALDRY.jerusalemCross} alt="Jerusalem Cross" className="w-24 mx-auto mb-6" />
          <div className="font-gothic text-3xl text-blood mb-3">Heraldry</div>
          <p className="text-white/60 text-sm leading-relaxed max-w-xs mx-auto">
            We borrow the codes of the chivalric orders — the Jerusalem cross, the Hospitaller robes, the silent dignity of those who wore them.
          </p>
        </div>
        <div className="text-center border-x border-white/10 px-8">
          <div className="font-gothic text-6xl text-blood mb-6">II</div>
          <div className="font-gothic text-3xl text-blood mb-3">Caribbean</div>
          <p className="text-white/60 text-sm leading-relaxed max-w-xs mx-auto">
            Saint Barthélemy gave us our colors: black volcanic sand, blood sunset, bone-white coral.
          </p>
        </div>
        <div className="text-center">
          <div className="font-gothic text-6xl text-blood mb-6">III</div>
          <div className="font-gothic text-3xl text-blood mb-3">Atelier</div>
          <p className="text-white/60 text-sm leading-relaxed max-w-xs mx-auto">
            Every piece is hand-finished in Gustavia. We refuse mass production. Limited series, no restock, no compromise.
          </p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 md:px-12 mt-32 text-center">
        <div className="font-gothic text-blood text-7xl md:text-9xl leading-none">"</div>
        <p className="font-gothic text-2xl md:text-4xl leading-snug text-bone mt-6">
          We dress kings who do not need crowns.
        </p>
        <div className="text-xs font-bold tracking-[0.3em] uppercase text-white/40 mt-8">
          — The Beaudoin Manifesto
        </div>
      </section>
    </div>
  );
}
